import Icon from '../../../components/AppIcon';

const ReportTemplateCard = ({ template, onSelect, isSelected }) => {
  const getCategoryColor = (category) => {
    switch (category) {
      case 'operational':
        return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
      case 'financial':
        return 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400';
      case 'compliance':
        return 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400';
      default:
        return 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400';
    }
  };

  return (
    <div
      onClick={() => onSelect(template)}
      className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 hover:shadow-md ${
        isSelected
          ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
      }`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
          e?.preventDefault();
          onSelect(template);
        }
      }}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={template?.icon} size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h4 className="font-semibold text-sm text-foreground">{template?.name}</h4>
            <span className={`text-xs px-2 py-0.5 rounded-full ${getCategoryColor(template?.category)}`}>
              {template?.category}
            </span>
          </div>
        </div>
        {isSelected && (
          <Icon name="CheckCircle2" size={20} color="var(--color-primary)" />
        )}
      </div>
      <p className="text-xs text-muted-foreground mb-3">{template?.description}</p>
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span className="flex items-center gap-1">
          <Icon name="Clock" size={14} />
          {template?.lastUsed}
        </span>
        <span className="flex items-center gap-1">
          <Icon name="TrendingUp" size={14} />
          {template?.usageCount} uses
        </span>
      </div>
    </div>
  );
};

export default ReportTemplateCard;